/**
 * RideXelite Brand Logo — mimics the flyer's mark:
 * gold car silhouette + "Ride" (white) + gold "X" + "Elite" (white)
 * + underlined "SERVICES" wordmark below.
 */
export const BrandLogo = ({ compact = false, className = "" }) => {
  const textSize = compact ? "text-2xl" : "text-3xl";
  return (
    <div className={`inline-flex flex-col items-center leading-none ${className}`} aria-label="RideXelite Services">
      {!compact && (
        <svg
          viewBox="0 0 120 34"
          className="w-14 h-4 mb-1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4 26 C 22 8, 42 4, 60 4 C 78 4, 98 8, 116 26"
            stroke="#D4AF37"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M22 22 L 34 14 M 86 14 L 98 22"
            stroke="#D4AF37"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <circle cx="34" cy="26" r="4" fill="#D4AF37" />
          <circle cx="86" cy="26" r="4" fill="#D4AF37" />
        </svg>
      )}
      <div className={`font-serif-display font-bold tracking-tight text-white ${textSize} flex items-baseline`}>
        <span>Ride</span>
        <span
          className="mx-[1px] font-black italic"
          style={{
            color: "#D4AF37",
            textShadow: "0 0 12px rgba(212,175,55,0.4)",
          }}
        >
          X
        </span>
        <span>Elite</span>
      </div>
      {!compact && (
        <div
          className="mt-1 relative text-[0.55rem] tracking-[0.45em] text-white font-medium"
        >
          <span className="absolute -left-3 top-1/2 w-2 h-px bg-[#D4AF37]" />
          SERVICES
          <span className="absolute -right-3 top-1/2 w-2 h-px bg-[#D4AF37]" />
        </div>
      )}
    </div>
  );
};

export default BrandLogo;
